<template>
  <v-menu v-model="closeOnClick" offset-y left bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="finishedConsultasSaldo.length < 1"
        @click="!closeOnClick"
        v-bind="attrs"
        v-on="on"
        depressed
        icon
        class="mr-4"
      >
        <v-badge
          style="position: relative; left: 0px"
          dot
          :color="hasConsultaSaldoDisponivel ? 'warning' : 'transparent'"
          overlap
          content=""
          bottom
        >
          <v-icon large color="">mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list>
      <small
        class="font-weight-black ml-2"
        style="position: relative; bottom: 4px"
      >
        Notificações
      </small>
      <v-list-item-group>
        <small v-show="!finishedConsultasSaldo.length" class="ma-4">
          Nenhuma consulta encontrada
        </small>
        <div
          v-for="(item, i) in finishedConsultasSaldo"
          :key="i"
          class="pb-1 px-4"
          :class="!item.visualizado && 'green4'"
          :style="`border-top: 1px solid silver;${
            !item.visualizado && 'cursor:pointer'
          }`"
          @click.stop="!item.visualizado && goToConsultaSaldo(item.id)"
        >
          <small>
            <p class="py-0 my-0 pt-2">
              Consulta {{ item.visualizado ? 'anterior' : 'disponível' }}
              <b>{{ `(${item.numero_resultados} resultados)` }}</b>
            </p>
            <p class="py-0 my-0">Número do contrato: {{ item.titulo }}</p>
            <div v-if="item.is_consulta_titulo_indisponivel">
              <p class="py-0 my-0">
                Dados indisponíveis. Por favor, tente mais tarde.
              </p>
            </div>
            <div v-else>
              <p class="py-0 my-0">
                Valor financiado: {{ mascara_dinheiro(item.valor_financiado) }}
              </p>
              <p class="py-0 my-0">
                Nº parcelas: {{ item.numero_parcelas_total }}
              </p>
              <p class="py-0 my-0">
                Nº parcelas quitadas: {{ item.numero_parcelas_pagas }}
              </p>
              <p class="py-0 my-0 pb-2">
                Saldo devedor: {{ mascara_dinheiro(item.saldo_devedor) }}
              </p>
            </div>
          </small>
        </div>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex';
import masks from '@/mixins/masks.js';
import { store } from 'pioneira-ui';

export default {
  mixins: [masks],
  data: () => ({
    closeOnClick: false,
    finishedConsultasSaldo: [],
    hasConsultaSaldoDisponivel: false,
    newRequestTimer: null,
  }),
  watch: {
    closeOnClick() {
      this.hasConsultaSaldoDisponivel = false;
    },
  },
  mounted() {
    if (store.state.user.id) {
      this.proceedGetfinishedConsultasSaldo();

      this.newRequestTimer = setInterval(() => {
        this.proceedGetfinishedConsultasSaldo();
      }, 10000);
    }
  },
  beforeDestroy() {
    if (this.newRequestTimer) {
      clearInterval(this.newRequestTimer);
    }
  },
  methods: {
    ...mapActions('ModuleConsultaSaldo', ['getfinishedConsultasSaldo']),
    ...mapActions('ModuleAlertas', ['triggerDataProcessError']),

    goToConsultaSaldo(id) {
      this.closeOnClick = false;
      this.$router.push(`/consulta-de-saldo/${id}`);
    },

    async proceedGetfinishedConsultasSaldo() {
      this.getfinishedConsultasSaldo()
        .then((data) => {
          let response = data.data.data;
          let dados = [];

          response.forEach(function (key, index) {
            const parsed_data = JSON.parse(key.quitacao_saldo_titulos[0].dados);

            dados.push({
              id: key.id,
              visualizado: key.visualizado,
              titulo: parsed_data.titulo,
              numero_resultados: key.quitacao_saldo_titulos.length,
              valor_financiado: parsed_data.valor_financiado,
              numero_parcelas_total: parsed_data.numero_parcelas_total,
              numero_parcelas_pagas: parsed_data.numero_parcelas_pagas,
              saldo_devedor: parsed_data.saldo_devedor,
              is_consulta_titulo_indisponivel:
                parsed_data.is_consulta_titulo_indisponivel,
            });
          });

          this.finishedConsultasSaldo = dados;
          if (
            this.finishedConsultasSaldo.some((e) => e.visualizado === false)
          ) {
            this.hasConsultaSaldoDisponivel = true;
          }
        })
        .catch((error) => {
          this.triggerDataProcessError();
        });
    },
  },
};
</script>

<style>
.p-nav {
  width: 246px;
}
.p-nav-lista {
  font-family: 'Exo';
  min-height: 30px;
  font-style: normal;
}
.p-nav-name {
  font-weight: 800;
  font-size: 15px;
  line-height: 20px;
  color: #1a1a1a;
  padding-left: 0px;
  border-bottom: 1px solid #cccccc;
}
.p-nav-sair {
  font-weight: 400;
  font-size: 16px;

  line-height: 24px;
  color: #1a1a1a;
  padding-left: 0px;
  border-bottom: 1px solid #cccccc;
}
.p-nav-sair:hover {
  background-color: #fff;
}
.p-nav-versao {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-left: 0px;
  color: #8c8c8c;
}
</style>
